import { useMemo } from "react";
import "./day-plan-styles/DayPlanParent.css";
import { useDataContext } from "../../data-context/DataContextProvider";
import { getDayViewMode } from "../../utils/timeSegmentation";
import DayPlanControls from "./day-plan-components/DayPlanControls";
import HourlyPlan from "./HourlyPlan";
import DailyPlan from "./DailyPlan";
import CustomPlan from "./CustomPlan";

function DayPlan() {
  const { selectedDayView } = useDataContext();

  const viewMode = useMemo(
    () => getDayViewMode(selectedDayView),
    [selectedDayView],
  );

  return (
    <div id="day-plan-wrapper">
      <DayPlanControls />
      {viewMode === "hourly" ? (
        <HourlyPlan />
      ) : viewMode === "custom" ? (
        <CustomPlan />
      ) : (
        <DailyPlan />
      )}
    </div>
  );
}

export default DayPlan;
